import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-lg border border-gray-200 bg-white" }
const _hoisted_2 = { class: "divide-y divide-gray-100" }
const _hoisted_3 = ["onMouseenter", "onFocusin"]
const _hoisted_4 = { class: "flex items-center justify-between gap-3" }
const _hoisted_5 = { class: "min-w-0" }
const _hoisted_6 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_7 = { class: "text-xs leading-snug text-gray-500" }
const _hoisted_8 = { class: "flex shrink-0 items-start gap-2" }
const _hoisted_9 = {
  key: 0,
  class: "mt-1.5 flex items-center gap-1 text-xs text-amber-700"
}

import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid'
import { computed, ref, watch } from 'vue'

import ColorSwatch from './ColorSwatch.vue'
import ResetButton from './ResetButton.vue'
import { isHardToRead } from './websiteColors'


export default {
  __name: 'ColorPanel',
  props: {
  modelValue: { type: Object, required: true },
  defaults: { type: Object, required: true },
  elements: { type: Array, required: true }
},
  emits: ['update:modelValue', 'highlight'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const customized = computed(() =>
  props.elements.some(element =>
    element.slots.some(slot => (props.modelValue[slot.key] || null) !== (props.defaults[slot.key] || null))
  )
)

const hovered = ref(null)
const focused = ref(null)
const picking = ref(null)

const pick = (id, isOpen) => {
  if (isOpen) picking.value = id
  else if (picking.value === id) picking.value = null
}

watch(
  () => hovered.value ?? picking.value ?? focused.value,
  part => emit('highlight', part)
)

const set = (key, value) => emit('update:modelValue', { ...props.modelValue, [key]: value })

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "border-b border-gray-200 px-3.5 py-2.5" }, [
      _createElementVNode("h4", { class: "text-sm font-semibold text-gray-900" }, "Colors")
    ], -1)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.elements, (element) => {
        return (_openBlock(), _createElementBlock("li", {
          key: element.id,
          class: "px-3.5 py-3 transition-colors hover:bg-gray-50",
          onMouseenter: $event => (hovered.value = element.id),
          onMouseleave: _cache[0] || (_cache[0] = $event => (hovered.value = null)),
          onFocusin: $event => (focused.value = element.id),
          onFocusout: _cache[1] || (_cache[1] = $event => (focused.value = null))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(element.label), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(element.hint), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.slots, (slot) => {
                return (_openBlock(), _createBlock(ColorSwatch, {
                  key: slot.key,
                  "model-value": __props.modelValue[slot.key] || null,
                  "default-value": __props.defaults[slot.key] || null,
                  site: slot.site,
                  label: `${element.label} - ${slot.label.toLowerCase()}`,
                  caption: slot.label,
                  "onUpdate:modelValue": $event => (set(slot.key, $event)),
                  onToggle: isOpen => pick(element.id, isOpen)
                }, null, 8, ["model-value", "default-value", "site", "label", "caption", "onUpdate:modelValue", "onToggle"]))
              }), 128))
            ])
          ]),
          (_unref(isHardToRead)(element, __props.modelValue))
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                _createVNode(_unref(ExclamationTriangleIcon), {
                  class: "h-3.5 w-3.5 shrink-0",
                  "aria-hidden": "true"
                }),
                _cache[3] || (_cache[3] = _createTextVNode(" Hard to read - pick colors further apart. ", -1))
              ]))
            : _createCommentVNode("", true)
        ], 40, _hoisted_3))
      }), 128))
    ]),
    _createVNode(ResetButton, {
      disabled: !customized.value,
      question: "Put every color back to the default?",
      onReset: _cache[2] || (_cache[2] = $event => (emit('update:modelValue', { ...__props.defaults })))
    }, null, 8, ["disabled"])
  ]))
}
}

}